import { render, staticRenderFns } from "./Authority.vue?vue&type=template&id=5dd3ecb7"
import script from "./Authority.vue?vue&type=script&lang=js"
export * from "./Authority.vue?vue&type=script&lang=js"
import style0 from "./Authority.vue?vue&type=style&index=0&id=5dd3ecb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports